import { render, staticRenderFns } from "./receiptOrder.vue?vue&type=template&id=cff66e58&scoped=true"
import script from "./receiptOrder.vue?vue&type=script&lang=js"
export * from "./receiptOrder.vue?vue&type=script&lang=js"
import style0 from "./receiptOrder.vue?vue&type=style&index=0&id=cff66e58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff66e58",
  null
  
)

export default component.exports